/* Constrained search Location — UI publique responsive */

.gas-loc-csearch {
    --gas-loc-csearch-gap: var(--gas-space-4, 16px);
    max-width: 768px;
    margin: 0 auto;
    padding: var(--gas-space-4, 16px);
    color: var(--gas-color-intent-fg, inherit);
}

.gas-loc-csearch__header {
    margin-bottom: var(--gas-loc-csearch-gap);
}

.gas-loc-csearch__title {
    font-size: var(--gas-font-size-xl, 24px);
    font-weight: 700;
    margin: 0 0 var(--gas-space-2, 8px);
    line-height: 1.25;
}

.gas-loc-csearch__intro {
    margin: 0;
    color: var(--gas-color-intent-muted, #555);
    font-size: var(--gas-font-size-m, 16px);
}

/* Variante assistant — encadré distinct monté DANS le catalogue, au-dessus du
   filtre lexical. Pleine largeur du conteneur parent, clairement délimité. */
.gas-loc-csearch--assistant {
    max-width: none;
    margin: 0 0 var(--gas-space-6, 24px);
    padding: var(--gas-space-4, 16px);
    border: 1px solid var(--gas-color-border, #ddd);
    border-radius: var(--gas-radius-l, 12px);
    background: var(--gas-color-surface-alt, var(--gas-color-surface, #fafafa));
}

.gas-loc-csearch--assistant .gas-loc-csearch__title {
    font-size: var(--gas-font-size-l, 20px);
}

.gas-loc-csearch--assistant .gas-loc-csearch__intro {
    font-size: var(--gas-font-size-s, 14px);
}

.gas-loc-csearch__form {
    display: flex;
    flex-direction: column;
    gap: var(--gas-space-2, 8px);
    margin-bottom: var(--gas-loc-csearch-gap);
}

.gas-loc-csearch__label {
    font-weight: 600;
    font-size: var(--gas-font-size-s, 14px);
}

.gas-loc-csearch__input {
    width: 100%;
    min-height: 88px;
    padding: var(--gas-space-3, 12px);
    border: 1px solid var(--gas-color-intent-border, #ccc);
    border-radius: var(--gas-radius-control, 8px);
    font: inherit;
    line-height: 1.4;
    resize: vertical;
    background: var(--gas-color-surface-raised, #fff);
    color: inherit;
}

.gas-loc-csearch__input:focus {
    outline: 2px solid var(--gas-color-intent-focus, #2563eb);
    outline-offset: 2px;
}

.gas-loc-csearch__input:disabled {
    opacity: 0.7;
}

.gas-loc-csearch__form-actions {
    display: flex;
    flex-wrap: wrap;
    gap: var(--gas-space-2, 8px);
    align-items: center;
}

.gas-loc-csearch__examples {
    margin-bottom: var(--gas-loc-csearch-gap);
}

.gas-loc-csearch__examples-label {
    font-size: var(--gas-font-size-s, 14px);
    color: var(--gas-color-intent-muted, #555);
    margin: 0 0 var(--gas-space-2, 8px);
}

.gas-loc-csearch__examples ul {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: var(--gas-space-2, 8px);
}

.gas-loc-csearch__example {
    display: block;
    width: 100%;
    text-align: left;
    padding: var(--gas-space-3, 12px);
    border: 1px dashed var(--gas-color-intent-border, #ccc);
    border-radius: var(--gas-radius-control, 8px);
    background: var(--gas-color-surface-subtle, #f8f8f8);
    color: inherit;
    font: inherit;
    cursor: pointer;
}

.gas-loc-csearch__example:hover,
.gas-loc-csearch__example:focus-visible {
    border-style: solid;
    border-color: var(--gas-color-intent-focus, #2563eb);
    outline: none;
}

.gas-loc-csearch__live {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
}

.gas-loc-csearch__results {
    display: flex;
    flex-direction: column;
    gap: var(--gas-loc-csearch-gap);
    margin-top: var(--gas-loc-csearch-gap);
}

.gas-loc-csearch__section-title,
.gas-loc-csearch__subhead {
    font-size: var(--gas-font-size-m, 16px);
    font-weight: 600;
    margin: 0 0 var(--gas-space-2, 8px);
}

.gas-loc-csearch__interp,
.gas-loc-csearch__solution {
    padding: var(--gas-space-4, 16px);
    border: 1px solid var(--gas-color-intent-border, #ddd);
    border-radius: var(--gas-radius-card, 12px);
    background: var(--gas-color-surface-raised, #fff);
}

.gas-loc-csearch__solution--full {
    border-color: var(--gas-color-intent-success, #16a34a);
}

.gas-loc-csearch__solution--partial,
.gas-loc-csearch__solution--alt {
    border-color: var(--gas-color-intent-warning, #ca8a04);
}

.gas-loc-csearch__solution--none {
    border-color: var(--gas-color-intent-danger, #dc2626);
}

.gas-loc-csearch__solution-head {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: var(--gas-space-2, 8px);
    margin-bottom: var(--gas-space-3, 12px);
}

.gas-loc-csearch__alt-label {
    font-size: var(--gas-font-size-s, 14px);
    color: var(--gas-color-intent-muted, #555);
}

.gas-loc-csearch__label {
    font-weight: 600;
}

.gas-loc-csearch__period {
    margin: 0 0 var(--gas-space-3, 12px);
}

.gas-loc-csearch__period--missing {
    color: var(--gas-color-intent-warning-fg, #854d0e);
}

.gas-loc-csearch__needs,
.gas-loc-csearch__explanations,
.gas-loc-csearch__allocs ul,
.gas-loc-csearch__unmet ul {
    list-style: none;
    margin: 0;
    padding: 0;
}

.gas-loc-csearch__need,
.gas-loc-csearch__alloc {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: var(--gas-space-2, 8px);
    padding: var(--gas-space-2, 8px) 0;
    border-bottom: 1px solid var(--gas-color-intent-border-subtle, #eee);
}

.gas-loc-csearch__need:last-child,
.gas-loc-csearch__alloc:last-child {
    border-bottom: 0;
}

.gas-loc-csearch__need-text,
.gas-loc-csearch__alloc-name {
    font-weight: 500;
    flex: 1 1 auto;
    min-width: 128px;
}

.gas-loc-csearch__alloc-avail {
    font-size: var(--gas-font-size-s, 14px);
    color: var(--gas-color-intent-muted, #555);
}

.gas-loc-csearch__explanations {
    margin-bottom: var(--gas-space-3, 12px);
}

.gas-loc-csearch__explanations li {
    padding: var(--gas-space-1, 4px) 0;
    font-size: var(--gas-font-size-s, 14px);
    color: var(--gas-color-intent-muted, #444);
}

.gas-loc-csearch__unmet {
    margin: var(--gas-space-3, 12px) 0;
    padding: var(--gas-space-3, 12px);
    border-radius: var(--gas-radius-control, 8px);
    background: var(--gas-color-intent-warning-bg, #fef9c3);
}

.gas-loc-csearch__unmet-reason {
    font-size: var(--gas-font-size-s, 14px);
    color: var(--gas-color-intent-muted, #555);
}

.gas-loc-csearch__actions {
    display: flex;
    flex-wrap: wrap;
    gap: var(--gas-space-2, 8px);
    margin-top: var(--gas-space-3, 12px);
}

.gas-loc-csearch__no-mutation-hint {
    margin: var(--gas-space-2, 8px) 0 0;
    font-size: var(--gas-font-size-xs, 12px);
    color: var(--gas-color-intent-muted, #666);
}

.gas-loc-csearch__query-id {
    margin: 0;
    font-size: var(--gas-font-size-s, 14px);
    color: var(--gas-color-intent-muted, #555);
    word-break: break-all;
}

.gas-loc-csearch__query-id code {
    font-size: 0.85em;
}

.gas-rental-cart__from-search {
    margin: 0 0 var(--gas-space-3, 12px);
    padding: var(--gas-space-2, 8px) var(--gas-space-3, 12px);
    border-radius: var(--gas-radius-control, 8px);
    background: var(--gas-color-intent-info-bg, #eff6ff);
    font-size: var(--gas-font-size-s, 14px);
}

/* Mobile */
@media (max-width: 640px) {
    .gas-loc-csearch {
        padding: var(--gas-space-3, 12px);
    }

    .gas-loc-csearch__title {
        font-size: var(--gas-font-size-l, 20px);
    }

    .gas-loc-csearch__form-actions,
    .gas-loc-csearch__actions {
        flex-direction: column;
        align-items: stretch;
    }

    .gas-loc-csearch__form-actions .gas-button,
    .gas-loc-csearch__actions .gas-button {
        width: 100%;
        justify-content: center;
    }
}

/* Clavier / focus visible renforcé */
.gas-loc-csearch :focus-visible {
    outline: 2px solid var(--gas-color-intent-focus, #2563eb);
    outline-offset: 2px;
}

/* Mode consultation : réponse franche + prochaine disponibilité */
.gas-loc-csearch__answers {
    margin: var(--gas-space-3, 12px) 0;
}

.gas-loc-csearch__answer {
    margin: 0 0 var(--gas-space-1, 4px);
    font-size: var(--gas-font-size-l, 20px);
    font-weight: 600;
    line-height: 1.3;
}

.gas-loc-csearch__answer.is-no {
    color: var(--gas-color-intent-muted, #555);
}

.gas-loc-csearch__rec-state.is-now {
    color: var(--gas-color-success-fg, #15803d);
    font-weight: 600;
}

.gas-loc-csearch__rec-note {
    color: var(--gas-color-intent-muted, #666);
    font-size: var(--gas-font-size-s, 14px);
}

.gas-loc-csearch__rec--nearest {
    opacity: 0.85;
}
